module.exports = __webpack_public_path__ + "static/img/broker1.05cf10e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/broker1.png
// module id = NPzc
// module chunks = 0